<template>
  <q-tooltip max-width="250px">{{ ABNORMAL_LEASE_SPIKE_MESSAGE }}</q-tooltip>
</template>

<script lang="ts">
export const ABNORMAL_LEASE_SPIKE_MESSAGE =
  'An abnormal lease spike was detected in this period. This typically happens when a property changes management or a new listing portal is activated.'

export default {
  name: 'AbnormalLeaseSpikeTooltip',
  data() {
    return {
      ABNORMAL_LEASE_SPIKE_MESSAGE
    }
  }
}
</script>
